<template>
  <div class="consultation">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%"
      @close="setDialogClosed" append-to-body>
      <el-container class="container" direction="vertical">
        <el-descriptions :column="4" border>

          <el-descriptions-item span="4" label="协诊类型">
            {{ lastPageValue.codiagServiceName }}
          </el-descriptions-item>

          <el-descriptions-item span="4" label="协诊状态">
            {{ lastPageValue.codiagStatus }}
          </el-descriptions-item>

          <el-descriptions-item span="4" label="处置方式">
            <el-radio v-model="listQueryData.codiagDealResult" label="线上协诊">线上协诊</el-radio>
            <el-radio v-model="listQueryData.codiagDealResult" label="门诊">门诊</el-radio>
            <el-radio v-model="listQueryData.codiagDealResult" label="住院">住院</el-radio>
          </el-descriptions-item>

          <template v-if="listQueryData.codiagDealResult == '线上协诊'">
            <el-descriptions-item span="4" label="*用药指导">
              <el-button type="primary" size="small" @click="addDrug()" style="margin-bottom: 5px;">新增用药</el-button>
              <el-descriptions :column="1" border>
                <el-descriptions-item label="*用药" v-for="(item, index) in listQueryData.medicines" :key="index">
                  <el-descriptions :column="4" border>
                    <el-descriptions-item span="2" label="药物名称">
                      <el-select filterable remote reserve-keyword :remote-method="loadAll" :loading="loading1"
                        v-model="item.medicineName" placeholder="请输入关键词...">
                        <el-option v-for="(item, index) in medicineNameOptions" :label="item.name" :value="item.name"
                          :key="index"></el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用药次数/日">
                      <el-input v-model="item.freq"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用量/次">
                      <el-input v-model="item.dosage"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="用药时间">
                      <el-input v-model="item.takeMethod"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item span="4" label="注意事项">
                      <el-select multiple v-model="item.remarks" placeholder="请选择...">
                        <el-option v-for="(item, index) in remarksOptions" :key="index" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="4" label="操作">
                      <el-button type="primary" size="small" @click="deleteDrug(index)">删除</el-button>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*其他建议">
              <el-input type="textarea" v-model="listQueryData.dietAdvice"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*生活方式指导">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="4" label="日吸烟量指导(支/天)">
                  <el-input v-model="listQueryData.smokePerdayTarget"></el-input>
                </el-descriptions-item>
                <el-descriptions-item span="4" label="日饮酒量指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="4" label="饮酒品类">
                      <el-select v-model="listQueryData.drinkType" placeholder="请选择">
                        <el-option v-for="item in drinkTypeList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item style="display: flex;" span="4" label="饮酒量">
                      <el-input style="width:80px" v-model="listQueryData.drinkPerdayTarget"></el-input>
                      <el-select style="width:80px" v-model="listQueryData.drinkUnit" placeholder="请选择">
                        <el-option v-for="item in drinkUnitList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                  </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item :span="4" label="*运动行为指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="*运动形式">
                      <el-select v-model="listQueryData.sportType" placeholder="请选择" @change="sportTypeSelectChange">
                        <el-option v-for="item in sportTypeList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动时间">
                      <el-select multiple v-model="listQueryData.sportPeriod" placeholder="请选择"
                        :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in dosageList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动时长">
                      <el-select v-model="listQueryData.sportMinutesEach" placeholder="请选择"
                        :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in sportMinutesEachList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动频次">
                      <el-select v-model="listQueryData.sportFreq" placeholder="请选择" :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in sportFreqList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item span="4" label="*饮食指导">
                  <el-select multiple v-model="listQueryData.dietGuides" placeholder="请选择...">
                    <el-option v-for="(item, index) in dietGuidesOptions" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>

                </el-descriptions-item>

              </el-descriptions>
            </el-descriptions-item>
            <!-- 
            <el-descriptions-item span="4" label="*随诊建议">
              <el-select v-model="onLineList" placeholder="请选择...">
                <el-option v-for="(x) in dietGuidesOptions" :key="x.id" :label="x.name" :value="x.value"></el-option>
              </el-select>
            </el-descriptions-item> -->

            <el-descriptions-item span="2" label="复查时间">
              <el-checkbox v-model="noReviewNeeded" style="margin-right: 8px;">无需复查</el-checkbox>
              <el-date-picker type="date" placeholder="选择复查时间" v-model="listQueryData.reviewTime" :disabled="noReviewNeeded"></el-date-picker>
            </el-descriptions-item>

            <el-descriptions-item span="2" label="复查频次">
              <el-select v-model="listQueryData.reviewFreq" placeholder="请选择">
                <el-option v-for="item in reviewFreqOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-descriptions-item>
          </template>

          <template v-if="listQueryData.codiagDealResult == '门诊'">
            <el-descriptions-item span="4" label="*门诊治疗">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="2" label="*检查">
                  <el-select multiple filterable remote reserve-keyword :remote-method="remoteMethod1"
                    :loading="loading1" v-model="listQueryData.exams" placeholder="请输入关键词...">
                    <el-option v-for="(item, index) in examsOptions" :label="item.itemName" :value="item.itemName"
                      :key="index"></el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item span="2" label="*检验">
                  <el-select multiple filterable remote reserve-keyword :remote-method="remoteMethod2"
                    :loading="loading1" v-model="listQueryData.tests" placeholder="请输入关键词...">
                    <el-option v-for="(item, index) in testsOptions" :label="item.itemName" :value="item.itemName"
                      :key="index"></el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*其他建议">
              <el-input type="textarea" v-model="listQueryData.outpatientAdvice"></el-input>
            </el-descriptions-item>
          </template>

          <template v-if="listQueryData.codiagDealResult == '住院'">
            <el-descriptions-item span="4" label="*住院指导">
              <el-select multiple v-model="listQueryData.inpatientGuides" placeholder="请选择...">
                <el-option v-for="(item, index) in inpatientGuidesOptions" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*其他建议">
              <el-input type="textarea" v-model="listQueryData.inpatientAdvice"></el-input>
            </el-descriptions-item>
          </template>


          <el-descriptions-item span="4" label="协诊信息">
            <el-descriptions :column="4" border>
              <el-descriptions-item span="2" label="协诊医师">
                {{ listQueryData.name }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊机构">
                {{ listQueryData.deptName }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊科室">
                {{ listQueryData.codiagDeptName ? listQueryData.codiagDeptName : "尚未建立协诊科室信息" }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊机构电话">
                {{ listQueryData.hospitalPhone }}
              </el-descriptions-item>
              <el-descriptions-item span="2" label="协诊日期">
                {{ listQueryData.codiagTime }}
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">关闭</el-button>
        <el-button type="primary" @click="oneReferral">一键协诊</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCoDiagDirect, getUserInfos, getSysDicList, getlistClinicItem, getMedicineList } from "@/api/health/Patients";
export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      title: "一键协诊",
      showDialog: null,
      refRisk: null,
      refId: null,
      idcard: null,
      restaurants: [],
      timeout: null,
      lastPageValue: {
        doctorGroup: []
      },
      examsOptions: [],
      testsOptions: [],
      medicineNameOptions: [],
      sportTypeSelectDisable: false,
      reviewFreqOptions: [
        { label: "2-3次/周自测", value: "2-3次/周自测" },
        { label: "1次/周医生测", value: "1次/周医生测" }
      ],
      noReviewNeeded: false,
      listQueryData: {
        codiagDealResult: "线上协诊",
        smokePerdayTarget: "戒烟",
        drinkPerdayTarget: 0,
        dietAdvice: "无",
        dietGuides: [],
        inpatientGuides: [],
        drinkType: "无",
        drinkUnit: "两/天",
        medicines: [{
          medicineName: "",
          freq: "",
          dosage: "",
          remarks: [],
          takeMethod: ""
        }],
        outpatientAdvice: "饮食控制基础上，根据门诊检查结果调整用药",
        inpatientAdvice: "无",
        reviewFreq: "2-3次/周自测",
        sportType: "",
        sportPeriod: "",
        sportMinutesEach: "",
        sportFreq: ""
      },

      onLineList: [], // 线上
      outpatientList: [], // 门诊
      inpatientList: [], // 住院
      record: {},
      examsOptions: [],
      remarksOptions: [
        {
          label: "服药前请先查尿常规是否有异常", value: "服药前请先查尿常规是否有异常"
        },
        {
          label: "服药后请多喝水，饮水量每天大于等于2000ml", value: "服药后请多喝水，饮水量每天大于等于2000ml"
        },
        {
          label: "服药期间请每天清洗外阴部，避免尿路感染", value: "服药期间请每天清洗外阴部，避免尿路感染"
        },
        {
          label: "请饭后服药，若有腹痛、腹泻，需即时到门诊治疗", value: "请饭后服药，若有腹痛、腹泻，需即时到门诊治疗"
        },
      ],
      sportTypeList: [
        { label: '无', value: '无' },
        { label: '慢走', value: '慢走' },
        { label: '快走', value: '快走' },
        { label: '慢跑', value: '慢跑' },
        { label: '游泳', value: '游泳' },
        { label: '跳绳', value: '跳绳' },
        { label: '太极拳', value: '太极拳' },
      ],
      dosageList: [
        { label: "上午", value: "上午" },
        { label: "下午", value: "下午" },
        { label: "晚上", value: "晚上" },
      ],
      sportMinutesEachList: [
        { label: "10分钟", value: "10分钟" },
        { label: "10-20分钟", value: "10-20分钟" },
        { label: "20-30分钟", value: "20-30分钟" },
        { label: "大于30分钟", value: "大于30分钟" }
      ],
      sportFreqList: [
        { label: "一次", value: "一次" },
        { label: "两次", value: "两次" },
        { label: "三次", value: "三次" },
        { label: "三次以上", value: "三次以上" },
      ],
      drinkTypeList: [
        { label: "无", value: "无" },
        { label: "红酒", value: "红酒" },
        { label: "白酒", value: "白酒" },
        { label: "啤酒", value: "啤酒" },
      ],
      drinkUnitList: [
        { label: "两/天", value: "两/天" },
        { label: "瓶/天", value: "瓶/天" },
      ],
      dietGuidesOptions: [
        { label: "每餐主食≤2两", value: "每餐主食≤2两" },
        { label: "少油低盐", value: "少油低盐" },
        { label: "避免煎、炸、红烧等烹饪方式", value: "避免煎、炸、红烧等烹饪方式" },
        { label: "适度饮水", value: "适度饮水" }
      ],
      inpatientGuidesOptions: [
        { label: "您已线上连续2-3次管理，血糖仍控制差，建议住院系统治疗", value: "您已线上连续2-3次管理，血糖仍控制差，建议住院系统治疗" },
        { label: "您的血糖已达危急值，容易出现糖尿病急性并发症，请您尽快住院治疗", value: "您的血糖已达危急值，容易出现糖尿病急性并发症，请您尽快住院治疗" }
      ]
    }

  },
  created() {
    this.getSystemTime();
    this.getSystemDictList("肺结节协诊线上");
    this.getSystemDictList("肺结节协诊门诊");
    this.getSystemDictList("肺结节协诊住院");
  },
  watch: {},
  methods: {
    // 初始化界面
    async init(value) {
      console.warn('协诊详情', value);

      // this.refRisk = value.risk;

      // if (value.hasOwnProperty("ehr")) {
      //   this.lastPageValue = value.ehr;
      // } else {
      this.lastPageValue = value;
      // }

      console.warn('lastPageValue', this.lastPageValue);

      if (value.refType == "血压") {
        this.outpatientAdvice = "饮食清淡基础上，根据检查结果除外继发性高血压后调整用药";
        this.inpatientGuidesOptions = [
          { label: "您已线上连续2-3次管理，血压仍控制差，建议住院系统治疗", value: "您已线上连续2-3次管理，血压仍控制差，建议住院系统治疗" },
          { label: "您的血压已达危急值，容易出现高血压危象，心、脑血管意外等急性并发症，请您尽快住院治疗", value: "您的血压已达危急值，容易出现高血压危象，心、脑血管意外等急性并发症，请您尽快住院治疗" }
        ];
      } else if (value.refType == "血糖") {
        this.outpatientAdvice = "饮食控制基础上，根据门诊检查结果调整用药";
        this.inpatientGuidesOptions = [
          { label: "您已线上连续2-3次管理，血糖仍控制差，建议住院系统治疗", value: "您已线上连续2-3次管理，血糖仍控制差，建议住院系统治疗" },
          { label: "您的血糖已达危急值，容易出现糖尿病急性并发症，请您尽快住院治疗", value: "您的血糖已达危急值，容易出现糖尿病急性并发症，请您尽快住院治疗" }
        ];
      } else if (value.refType == "血脂") {
        this.outpatientAdvice = "您的LDL-C>2.6mmol/L，需强化降脂，生活方式干预，每三个月复查血脂。";
        this.inpatientGuidesOptions = [
          { label: "您的各项检查提示动脉硬化（ASCVD）高危且LDL-C>4.9mmol/L，建议住院进一步诊治。", value: "您的各项检查提示动脉硬化（ASCVD）高危且LDL-C>4.9mmol/L，建议住院进一步诊治。" },
        ];
      }

      if (value.doctorGroup != null) {
        this.lastPageValue.doctorGroup = value.doctorGroup;
      }
      // this.lastPageValue.bloodSugar = value.bloodSugar;

      this.getSystemTime();

      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          console.log(res, "获取协诊机构电话")
          this.listQueryData.hospitalPhone = res.data.hospitalPhone;
          this.listQueryData.name = res.data.name;
          this.listQueryData.deptName = res.data.hospitalName;
          this.listQueryData.codiagDeptName = res.data.deptName;

          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        if (typeName == "肺结节协诊线上") {
          this.onLineList = records;
        } else if (typeName == "肺结节协诊门诊") {
          this.outpatientList = records;
        } else if (typeName == "肺结节协诊住院") {
          this.inpatientList = records;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    setDialogClosed() {
      this.sportTypeSelectDisable = false;
      this.noReviewNeeded = false;
      this.listQueryData = {
        codiagDealResult: "线上协诊",
        smokePerdayTarget: "戒烟",
        drinkPerdayTarget: 0,
        examGuide: null,
        dietAdvice: "饮食控制基础上，根据门诊检查结果调整用药",
        dietGuides: [],
        inpatientGuides: [],
        sportType: "",
        sportPeriod: "",
        sportMinutesEach: null,
        sportFreq: null,
        drinkType: "无",
        drinkUnit: "两/天",
        exams: [],
        tests: [],
        outpatientAdvice: "无",
        inpatientAdvice: "无",
        medicines: [{
          medicineName: "",
          freq: "",
          dosage: ""
        }],
        reviewTime: null,
        reviewFreq: "2-3次/周自测"
      },
        this.showDialog = false;
    },
    loadAll(query) {
      this.medicineNameOptions = [];
      var params = { name: query }
      this.loading1 = true;
      getMedicineList(params).then((res) => {
        this.loading1 = false;
        if (res.msg == "success") {
          this.medicineNameOptions = res.data.records;
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    sportTypeSelectChange(e) {
      console.log(e);
      if (e == "无") {
        this.sportTypeSelectDisable = true;
      } else {
        this.sportTypeSelectDisable = false;
      }
    },
    // 远程搜索检查项目
    remoteMethod1(query) {
      this.examsOptions = [];
      var params1 = {
        itemCategory: "检查",
        name: query
      }

      if (query !== '') {
        this.loading1 = true;
        getlistClinicItem(params1).then(res => {
          this.loading1 = false;
          if (res.msg == "success") {
            setTimeout(() => {
              this.examsOptions = res.data.records;
            }, 200);
          }
        }).catch(error => {
          console.log(error);
        })
      } else {
        this.examsOptions = [];
      }

    },
    // 远程搜索检查项目
    remoteMethod2(query) {
      this.testsOptions = [];
      var params2 = {
        itemCategory: "检验",
        name: query
      }

      if (query !== '') {
        this.loading1 = true;
        getlistClinicItem(params2).then(res => {
          this.loading1 = false;
          if (res.msg == "success") {
            setTimeout(() => {
              this.testsOptions = res.data.records;
            }, 200);
          }
        }).catch(error => {
          console.log(error);
        })
      } else {
        this.testsOptions = [];
      }

    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);

      this.listQueryData.codiagTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
    // 一键协诊
    oneReferral() {
      if (this.listQueryData.codiagDealResult == '线上协诊') {
        if (this.listQueryData.medicines.length == 0) {
          this.$message({
            message: "请新增用药并输入！",
            type: "error"
          })
          return;
        }

        if (this.listQueryData.dietGuides.length == 0) {
          this.$message({
            message: "请选择饮食指导！",
            type: "error"
          })
          return;
        }

        if (!this.listQueryData.dietAdvice) {
          this.$message({
            message: "请输入其他建议！",
            type: "error"
          })
          return;
        }

        if (!this.listQueryData.sportType) {
          this.$message({
            message: "请选择运动行为指导中运动形式！",
            type: "error"
          })
          return;
        }

        if (this.sportTypeSelectDisable == false) {
          if (!this.listQueryData.sportPeriod) {
            this.$message({
              message: "请选择运动行为指导中运动时间！",
              type: "error"
            })
            return;
          } else {
            this.listQueryData.sportPeriod = this.listQueryData.sportPeriod.join(',');
          }

          if (!this.listQueryData.sportMinutesEach) {
            this.$message({
              message: "请选择运动行为指导中运动时长！",
              type: "error"
            })
            return;
          }

          if (!this.listQueryData.sportFreq) {
            this.$message({
              message: "请选择运动行为指导中运动频次！",
              type: "error"
            })
            return;
          }
        }else{
           this.listQueryData.sportPeriod = '';
        }


      } else if (this.listQueryData.codiagDealResult == '门诊') {

        this.listQueryData.sportPeriod = "";

        if (this.listQueryData.exams == 0) {
          this.$message({
            message: "请选择门诊处方中检查项目！",
            type: "error"
          })
          return;
        }

        if (this.listQueryData.tests == 0) {
          this.$message({
            message: "请选择门诊处方中检验项目！",
            type: "error"
          })
          return;
        }

        if (!this.listQueryData.outpatientAdvice) {
          this.$message({
            message: "请输入门诊建议！",
            type: "error"
          })
          return;
        }
      } else if (this.listQueryData.codiagDealResult == '住院') {

        this.listQueryData.sportPeriod = "";

        if (this.listQueryData.inpatientGuides == 0) {
          this.$message({
            message: "请选择住院指导！",
            type: "error"
          })
          return;
        }

        if (!this.listQueryData.inpatientAdvice) {
          this.$message({
            message: "请输入住院建议！",
            type: "error"
          })
          return;
        }
      }

      // 无需复查时，清空复查时间
      if (this.noReviewNeeded) {
        this.listQueryData.reviewTime = null;
      }

      var params = {};
      params.record = this.listQueryData;
      params.applyDiagnosis = this.lastPageValue.msgContent;
      params.patientId = this.lastPageValue.patientId;
      params.refRisk = this.refRisk;
      params.refType = this.lastPageValue.refType + '检测';
      if (this.lastPageValue.refType == '血糖') {
        params.codiagServiceName = '糖尿病协诊';

      } else if (this.lastPageValue.refType == '血压') {
        params.codiagServiceName = '高血压协诊';
      } else if (this.lastPageValue.refType == '血脂') {
        params.codiagServiceName = '高血脂协诊';
      } else {
        params.codiagServiceName = this.lastPageValue.refType + '协诊';
      }
      params.id = this.lastPageValue.id;
      params.refId = this.lastPageValue.refId;
      params.idcard = this.lastPageValue.idcard;

      console.warn("一键协诊payload：", params);

      getCoDiagDirect(params).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "协诊成功！",
            type: "success"
          })
          this.$emit("upDataList");
          this.showDialog = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          })
        }
      }).catch((error) => {
        console.log(error)
      }
      )
    },
    addDrug() {
      var drugItem = {
        medicineName: "",
        freq: "",
        dosage: "",
        remarks: [],
        takeMethod: ""
      };
      this.listQueryData.medicines.push(drugItem);
    },
    deleteDrug(index) {
      this.listQueryData.medicines.splice(index, 1);
    }
  }

}
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}

::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 120px;
  }
}
</style>